<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary font-weight-bold text-white">
      Pelaporan SKP
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>

    <div class="card-body">
      <!-- Form Tambah -->
      <div class="card border-0 shadow p-2">
        <!-- <div class="card-header bg-white text-muted h4">Tambah</div> -->
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="no_agt" class="font-weight-bold">Nomor Anggota</label>
                <input
                  type="text"
                  class="form-control"
                  id="no_agt"
                  placeholder="Masukkan Nomor Anggota"
                  v-model="formdata.nomorAnggota"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="nama" class="font-weight-bold">Nama Anggota</label>
                <input
                  type="text"
                  class="form-control"
                  id="nama"
                  placeholder="Masukkan Nama Anggota"
                  v-model="formdata.namaAnggota"
                />
              </div>              
            </div>            
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="email" class="font-weight-bold">Email</label>
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  placeholder="Masukkan Email"         
                  v-model="formdata.email"         
                />
              </div>              
            </div>            
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="no_telp" class="font-weight-bold">Nomor Telepon</label>
                <input
                  type="text"
                  class="form-control"
                  id="no_telp"
                  placeholder="Masukkan Nomor Telepon"      
                  v-model="formdata.nomorTelepon"            
                />
              </div>              
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="alamat" class="font-weight-bold">Alamat Anggota</label>
                <input
                  type="text"
                  class="form-control"
                  id="alamat"
                  placeholder="Masukkan Alamat"
                  v-model="formdata.alamatAnggota"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="nama" class="font-weight-bold">Kategori Anggota</label>
                <multiselect
                  class="mulit-select"              
                  placeholder="Pilih Kategori"
                  label="namaKategori"
                  track-by="namaKategori"
                  :show-labels="false"
                  required
                  v-model="kategori"                  
                  :options="kategoriAnggota"                
                  @select="changeKategori"                  
                ></multiselect>                                  
              </div>
              <div class="form-group col-md-6">
                <label for="kap" class="font-weight-bold">KAP</label>
                <multiselect
                  class="mulit-select"              
                  placeholder="Pilih Kategori"
                  label="nama_kap"
                  track-by="nama_kap"
                  :show-labels="false"
                  required
                  v-model="kap"                  
                  :options="optionsKap"                
                  @select="changeKap"
                ></multiselect>                  
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- Form Pelaporan SKP -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">Pelaporan SKP</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="skp" class="font-weight-bold">SKP IAPI</label>
                <div class="row">                  
                  <div class="form-group col-4">
                    <label for="skp-terstruktur" class="font-weight-bold">Terstruktur</label>
                    <input
                      type="number"
                      class="form-control"
                      id="skp-terstruktur"
                      placeholder="Terstruktur"
                      v-model="formdata.skpIapiTerstruktur"
                    />
                  </div>
                  <div class="form-group col-4">
                    <label for="skp-tidak-terstuktur" class="font-weight-bold">Tidak Terstruktur</label>
                    <input
                      type="number"
                      class="form-control"
                      id="skp-tidak-terstuktur"
                      placeholder="Tdk. Terstruktur"
                    />    
                  </div>
                  <div class="form-group col-4">
                    <label for="skp-assesment" class="font-weight-bold">Assesment</label>
                    <input
                    type="number"
                    class="form-control"
                    id="skp-assesment"
                    placeholder="Assesment"
                  />
                  </div>                                
                </div>
              </div>                        
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="skp" class="font-weight-bold">SKP Non IAPI</label>
                <div class="row">
                  <div class="form-group col-md-4">
                    <label for="skp-non-iapi-terstuktur" class="font-weight-bold">Terstruktur</label>
                    <input
                      type="number"
                      class="form-control"
                      id="skp-non-iapi-terstuktur"
                      placeholder="Terstruktur"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="skp-non-iapi-tidak-terstuktur" class="font-weight-bold">Tidak Terstruktur</label>
                    <input
                      type="number"
                      class="form-control"
                      id="skp-non-iapi-tidak-terstuktur"
                      placeholder="Tdk. Terstruktur"
                    />
                  </div>                  
                </div>
              </div>    
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="verif" class="font-weight-bold">Diverifikasi Pada</label>
                <input
                  type="text"
                  class="form-control"
                  id="verif"
                  placeholder="Pilih Tanggal Verifikasi"
                />
              </div>
            </div>
            <div class="form-row">              
              <div class="form-group col-md-12">
                <label for class="font-weight-bold">Status</label>
                <br />
                <div class="d-flex align-items-center">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" name="customRadio" id="aktif" />
                    <label class="custom-control-label" for="aktif">Aktif</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="customRadio"
                      id="tidak_aktif"
                    />
                    <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">
      <router-link to="/keanggotaan/pelaporan-skp">
        <Button class="btn btn-md btn-success px-4 py-2" type="submit" color="success">Simpan</Button>
      </router-link>
    </div>
  </div>
</template>

<script>
import KategoriAnggotaService from "@/services/keanggotaan/kategori-anggota.service";
import KapService from "@/services/keanggotaan/kap.service";
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  
  data() {
    return {
      kategoriAnggota: [],
      optionsKap: [],
      formdata: {
        nomorAnggota: '',
        namaAnggota: '',
        email: '',
        nomorTelepon: '',
        alamatAnggota: '',
        idKategoriAnggota: '',
        idKap: '',
        skpIapiTerstruktur: ''
      },
      kategori: {},
      kap: {}
    }
  },

  validations: {

  },

  mounted() {
    this.getKategoriAnggota();
    this.getKap();
  },

  watch: {

  },  

  methods: {
    getKategoriAnggota() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {          
          this.kategoriAnggota = response.data.data.content;
          this.kategori = this.kategoriAnggota[0];
          loader.hide();          
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getKap() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      KapService.getKap(0, 1000, 'default')
        .then((response) => {          
          this.optionsKap = response.data.data.content;
          this.kap = this.optionsKap[0];
          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    changeKategori(val) {
      this.formdata.idKategoriAnggota = val.idKategoriAnggota
      this.kategori = val;      
    },

    changeKap(val) {
      this.formdata.idKap = val.id_kap;
      this.kap = val      
    }
  }

}
</script>  

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>